(() => {
  if (customElements.get('toad-booking')) return;
  customElements.define('toad-booking', class extends HTMLElement {
    connectedCallback() {
      this.speed = Number(this.dataset.gridSpeed) || 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.updateGrid = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const size = parseFloat(getComputedStyle(this).getPropertyValue('--booking-grid-size')) || 56;
          const y = this.motion.matches ? 0 : ((innerHeight - this.getBoundingClientRect().top) * this.speed / 100) % size;
          this.style.setProperty('--booking-grid-y', `${y.toFixed(2)}px`);
          this.style.setProperty('--booking-grid-x', `${(-y * .2).toFixed(2)}px`);
        });
      };
      window.addEventListener('scroll', this.updateGrid, { passive: true });
      window.addEventListener('resize', this.updateGrid, { passive: true });
      this.motion.addEventListener('change', this.updateGrid);
      this.updateGrid();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateGrid);
      window.removeEventListener('resize', this.updateGrid);
      this.motion.removeEventListener('change', this.updateGrid);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
})();
